export default __webpack_public_path__ + "38113f645cea63a40f1a06cd9b1e990c.png";